/* eslint-disable import/prefer-default-export */
export const quoteRequestQueryKeys = {
  allQuotes: ["quotes", "all"],
  quoteTimerSettings: () => ["timer-settings"],
  quoteListing: (filters: any) => ["quotes", "list", filters],
  quoteV2Listing: (filters: any) => ["quotesV2", "list", filters],
  quoteDetails: (id: string) => ["quotes", "detail", id],
  quoteAuditTrailListing: (id: string) => ["audit-trail", "list", id],
  quoteProviderOptionsListing: (id: string) => ["provider-options", "list", id],
  quoteQuotationListing: (id: string) => ["quotation", "list", id],
  quoteCommentsListing: (id: string) => ["quotes", "list", id, "comments"],
};
